import type { RouteRecordRaw } from 'vue-router'
import {
  incidentRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName, tenantScopedRedirect } from './tenantScoped'

const createIncidentChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: '',
    ...maybeRouteName(withNames, 'incidents'),
    component: () => import('@/views/incident/IncidentList.vue'),
    meta: { permission: 'incident:record:view' }
  },
  {
    path: 'config',
    ...maybeRouteName(withNames, 'incident-config'),
    component: () => import('@/views/incident/IncidentConfig.vue'),
    meta: {
      permission: {
        any: [
          'incident:config:view',
          'incident:reminder_rule:view',
          'incident:reminder_log:view',
        ],
      },
    },
  },
  {
    path: 'resolved',
    ...maybeRouteName(withNames, 'incident-resolved'),
    component: () => import('@/views/incident/IncidentResolvedList.vue'),
    meta: { permission: 'incident:record:view' }
  },
  {
    path: 'reminder-rules',
    redirect: tenantScopedRedirect('/incidents/config?tab=rules')
  },
  {
    path: 'reminder-logs',
    redirect: tenantScopedRedirect('/incidents/config?tab=logs')
  },
  {
    path: ':id',
    ...maybeRouteName(withNames, 'incident-detail'),
    component: () => import('@/views/incident/IncidentDetail.vue'),
    meta: { permission: 'incident:record:view' }
  }
]

const createIncidentRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/incident/IncidentLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(incidentRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: incidentRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createIncidentChildren(withNames)
})

const incidentRoutes: RouteRecordRaw[] = [
  createIncidentRoute('t/:tenantCode/incidents', '/t/:tenantCode/incidents', true),
  createIncidentRoute('incidents', '/incidents', false),
]

export default incidentRoutes
